var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagebox" },
    [
      _c("div", { staticClass: "class-top" }, [
        _c("div", { staticClass: "right-nav" }, [
          _c(
            "ul",
            { staticClass: "nav-scroll" },
            _vm._l(_vm.classlist, function(item, index) {
              return _c(
                "li",
                {
                  key: item.index,
                  class: { active: _vm.cur == index },
                  on: {
                    click: function($event) {
                      return _vm.getclass(index, item.coursetype)
                    }
                  }
                },
                [_vm._v(_vm._s(item.classname))]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "class-typx" }, [
        _c(
          "div",
          { staticClass: "wx-child-box" },
          _vm._l(_vm.classconlist, function(item, index) {
            return _c(
              "div",
              {
                key: item.index,
                staticClass: "wc-child",
                on: {
                  click: function($event) {
                    return _vm.gonext(item.courseid)
                  }
                }
              },
              [
                _c("div", { staticClass: "wc-poster" }, [
                  _c("img", { attrs: { src: item.conpic } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wx-right" }, [
                  _c("ul", { staticClass: "wx-title-time" }, [
                    _c("li", { staticClass: "wx-tchild" }, [
                      _c("span", { staticClass: "tc-title" }, [
                        _vm._v(_vm._s(item.contitle))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "tc-time" }, [
                        _vm._v(
                          "共" +
                            _vm._s(item.classnum) +
                            "课时 | " +
                            _vm._s(item.classtime)
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "tc-price" }, [
                      _vm._v(_vm._s(item.price))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticClass: "user-box" }, [
                    _c("li", { staticClass: "user" }, [
                      _c("span", { staticClass: "user-img" }, [
                        _c("img", { attrs: { src: item.userpic } })
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "username" }, [
                        _vm._v(_vm._s(item.username))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "userstudy" }, [
                      _vm._v(_vm._s(item.usernum) + "人学习")
                    ])
                  ])
                ])
              ]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("footer-nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a4a5cbe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4a5cbe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/class/class.vue
// module id = null
// module chunks = 